module.exports = __webpack_public_path__ + "img/Please DO touch the artwork.4e2a23a3.gif";